import { styled } from '@mui/material';

import { ModalMode } from '@app-velocity/message-bus';

import { Box } from '../../../Box';
import { useModalWrapperContext } from '../../context/useModalWrapperContext';

export type ContentProps = {
  children: React.ReactNode;
  variant?: 'narrow' | 'auto';
  'data-testid'?: string;
};

const StyledModalContent = styled(Box)<{
  mode: ModalMode;
  variant?: 'narrow' | 'auto';
}>(({ mode, theme, variant }) => ({
  padding: `20px ${mode === 'default' ? '24px' : '16px'} 16px`,
  boxSizing: 'border-box',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: theme.constants.modalContentGap,
  overflow: 'auto',
  width: variant === 'narrow' ? '600px' : '100%',
}));

export const Content = ({ children, variant, ...rest }: ContentProps) => {
  const { mode } = useModalWrapperContext();

  return (
    <StyledModalContent
      data-testid={rest['data-testid']}
      mode={mode}
      variant={variant}
    >
      {children}
    </StyledModalContent>
  );
};
